export var TypeActionReconnectAfterLogin;
(function (TypeActionReconnectAfterLogin) {
    TypeActionReconnectAfterLogin["DisconnectedByLogin"] = "ReconnectAfterLogin > DisconnectedByLogin";
    TypeActionReconnectAfterLogin["ReconnectedAfterLogin"] = "ReconnectAfterLogin > ReconnectedAfterLogin";
})(TypeActionReconnectAfterLogin || (TypeActionReconnectAfterLogin = {}));
export var actionDisconnectedByLogin = function () { return ({
    type: TypeActionReconnectAfterLogin.DisconnectedByLogin,
}); };
export var actionReconnectAfterLogin = function () { return ({
    type: TypeActionReconnectAfterLogin.ReconnectedAfterLogin,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/reconnect-after-login/actionReconnectAfterLogin.ts
// module id = 289
// module chunks = 3